/** Current page hostname, or undefined outside a browser. */
export function getCurrentHostname(): string | undefined {
  if (typeof window === 'undefined') return undefined;
  try {
    return window.location?.hostname || undefined;
  } catch {
    return undefined;
  }
}
